import React from 'react'

export const NewServiceRequestButton = ({ showModal, setShowModal, disabled }) => {
    return (
        <button disabled={disabled} className='btn btn-info py-2 w-23 rounded-3' onClick={() => { setShowModal(!showModal) }}>
            <span className="mdi mdi-plus me-2"></span>Solicitud de servicio
        </button>
    )
}
